import React, { useContext, useEffect, useState } from "react";
import Geocode from "react-geocode";
import axios from "axios";
import config from "../../config/config";

import Map from "../components/Map";
import SearchContainer from "./SearchContainer";

import { MarkersContext } from "../contexts/markers-context";
import { GeolocationContext } from "../contexts/geolocation-context";
import { LocalizationContext } from "../contexts/localization-context";

const LayoutContainer = () => {
    const [markersState, setMarkersState] = useContext(MarkersContext);
    const [geolocationState, dispatchToGeolocation] = useContext(GeolocationContext);
    const [localizationState, setLocalizationState] = useContext(LocalizationContext);
    const [widgetName, setWidgetName] = useState(null);
    const googleMapsApiKey = document.getElementById("googleMapsApiKey").value;
    const internationalCountryName = "International";

    const geolocationSuccess = (position) => {
        Geocode.setApiKey(googleMapsApiKey);
        Geocode.fromLatLng(
            position.coords.latitude.toString(),
            position.coords.longitude.toString()
        ).then(
            (response) => {
                const address = response.results[0].formatted_address;
                dispatchToGeolocation({
                    type: "SET_USER_LOCATION",
                    payload: {
                        userBounds: response.results[0].geometry.viewport,
                        userAddress: address,
                    },
                });
            },
            (error) => {
                console.error(error.message);
            }
        );
    };

    const geolocationError = (error) => {
        dispatchToGeolocation({
            type: "SET_GEOLOCATION_ERROR_MESSAGE",
            payload: {
                geolocationErrorMessage: error.message,
            },
        });
    };

    useEffect(() => {
        const widgetNameElemValue = document.getElementById('widgetName').value;
        setWidgetName(widgetNameElemValue);
        const cultureId = document.getElementById("cultureId").value.toLowerCase();
        axios
            .get(config.baseUrl + "GetLocalization/" + widgetNameElemValue + "/" + cultureId)
            .then((response) => {
                setLocalizationState(response.data);
                dispatchToGeolocation({
                    type: "SET_COUNTRY_NAME",
                    payload: {
                        countryName: response.data.selectedCountry.name,
                        isLoading: true,
                    },
                });
            })
            .catch((err) => {
                console.log(err);
            });

        let locationOptions = {};
        if (
            navigator.userAgent.indexOf("MSIE") != -1 ||
            (!!document.documentMode == true && navigator.appVersion.indexOf("Win") != -1)
        ) {
            locationOptions = {
                enableHighAccuracy: false,
                maximumAge: 50000,
            };
        }
        navigator.geolocation.getCurrentPosition(
            geolocationSuccess,
            geolocationError,
            locationOptions
        );
    }, []);

    useEffect(() => {
        if (!geolocationState.countryName) return;
        const defaultCountryName = document.getElementById('defaultCountryName').value;
        axios
            .get(config.baseUrl + 'GetMapMarkers/' + widgetName + '/' + defaultCountryName)
            .then((response) => {
                setMarkersState(response.data);
                Geocode.setApiKey(googleMapsApiKey);
                if (geolocationState.countryName !== internationalCountryName) {
                    Geocode.fromAddress(`${geolocationState.countryName} country`).then(
                        (response) => {
                            dispatchToGeolocation({
                                type: "SET_MAP_BOUNDS",
                                payload: {
                                    bounds: response.results[0].geometry.viewport,
                                },
                            });
                            dispatchToGeolocation({ type: "SET_IS_LOADING", payload: false });
                            return;
                        }
                    );
                } else {
                    dispatchToGeolocation({
                        type: "SET_MAP_BOUNDS",
                        payload: {
                            bounds: {
                                southwest: { lat: -45, lng: -60 },
                                northeast: { lat: 75, lng: 60 },
                            },
                        },
                    });
                }
                dispatchToGeolocation({ type: "SET_IS_LOADING", payload: false });
            })
            .catch((err) => {
                dispatchToGeolocation({ type: "SET_IS_LOADING", payload: false });
                console.log(err);
            });
    }, [geolocationState.countryName, widgetName]);

    return (
        <>
            <div className="container">
                {localizationState && geolocationState.countryName && (
                    <SearchContainer googleMapsApiKey={googleMapsApiKey} />
                )}
            </div>
            <div className="container container--full-width-xs">
                <div className="relative pt-9/16 xs:pt-1/1 bg-gray-brown">
                    {geolocationState.isLoading ? (
                        <div className="loader-container">
                            <div className="loader"></div>
                        </div>
                    ) : (
                        <div className="w-full h-full">
                            <Map
                                isMarkerShown
                                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&v=3.exp&libraries=geometry,drawing,places`}
                                containerElement={<div className="w-full h-full" />}
                                mapElement={
                                    <div className="absolute top-0 left-0 w-full h-full map-element" />
                                }
                                markers={markersState}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default LayoutContainer;
